module.exports = __webpack_public_path__ + "img/猫窝-2.46da2a93.jpg";